/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { IconWarning, ButtonTertiary } from '@americanexpress/dls-react';

export const FxCustomAlert = ({
  errorMessage,
  errorModalLabel,
  showErrorModal,
}) => (
  <div className="flex flex-column">
    <div style={{ paddingTop: '5px' }}>
      <IconWarning
        size="sm"
        filled={true}
        theme={{ color: '#EA700B', fill: '#EA700B', marginRight: '10px' }}
      />
      <span style={{ color: '#EA700B' }}>
        {errorMessage}
      </span>
    </div>
    <ButtonTertiary
      id="errorModalButton"
      theme={{
        textAlign: 'start !important',
        marginLeft: '32px !important',
        padding: '0px !important',
        fontSize: '15px !important',
        border: 'none !important',
        '&:hover': {
          background: 'none !important',
        },
        '&:active': {
          background: 'none !important',
        },
        '&:focus': {
          outline: 'none !important',
          outlineOffset: '0px !important',
        },
      }}
      onClick={() => showErrorModal()}
    >
      {errorModalLabel}
    </ButtonTertiary>
  </div>
);

FxCustomAlert.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  errorModalLabel: PropTypes.string.isRequired,
  showErrorModal: PropTypes.func.isRequired,
};
